export enum RowInsertType {
    Above,
    Below,
    Clone,
    Delete,
};
